import MarshallLanding from "./MarshallLanding";
import "./marshall.css";
import Nav from "../Nav/Nav";
import PortableSpeakers from "./PortableSpeakers";
import MarshallHeadphones from "./MarshallHeadphones";
import Footer from "../Footer/Footer";
import RedirectBack from "../../resuable/RedirectBack";
import { useLocation } from "react-router-dom";

function Marshall() {
  const location = useLocation();
  console.log("Marshall location:", location?.state?.from);
  const from = location?.state?.from || '';
  return (
    <div className="marshal-screen">
      <Nav theme="dark" />
      {from.toLowerCase() === "bestincategory" && <RedirectBack steps={-1} from = {from}/>}
      <MarshallLanding />
      <PortableSpeakers />
      <MarshallHeadphones />
      <Footer />
    </div>
  );
}

export default Marshall;
